/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import Cookies from 'js-cookie'

const UserSession = {
  write: token => {
    if (process.env.REACT_APP_DOMAIN) {
      Cookies.set('user.session.token', token, { domain: process.env.REACT_APP_DOMAIN })
    } else {
      Cookies.set('user.session.token', token)
    }
  },
  read: () => {
    if (process.env.REACT_APP_DOMAIN) {
      return Cookies.get('user.session.token', { domain: process.env.REACT_APP_DOMAIN })
    }

    return Cookies.get('user.session.token')
  },
  delete: () => {
    if (process.env.REACT_APP_DOMAIN) {
      Cookies.remove('user.session.token', { domain: process.env.REACT_APP_DOMAIN })
    } else {
      Cookies.remove('user.session.token')
    }
  }
}

export default UserSession
